import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { useSelector } from "react-redux";
import { flattenRoutes } from "../utils";

const PageTitle = ({ title, to = "#" }) => {
  const appMenu = useSelector((state) => state.AppMenu);

  const { appConfig, notification } = useSelector((state) => state.App);

  const menuItems = flattenRoutes(appMenu.menuItems);

  const breadCrumbs =
    appMenu.activatedMenuItemIds &&
    appMenu.activatedMenuItemIds.map((active) =>
      menuItems.find((item) => item.id === active)
    );

  return (
    <Row>
      <Col>
        <Helmet>
          <meta name="theme-color" content="#65D4B3" />
          <meta
            name="title"
            content={`${appConfig?.name} - ${appConfig?.description}`}
          />
          <meta
            name="description"
            content={`${appConfig?.name} - ${appConfig?.description}`}
          />
          <title>
            {notification?.length > 0 ? `(${notification?.length})` : ""}&nbsp;
            {title} - {appConfig?.name} {appConfig?.description}
          </title>
        </Helmet>

        <div className="page-title-box">
          <div className="page-title-right">
            <Breadcrumb>
              {breadCrumbs?.map((breadCrumb) => (
                <BreadcrumbItem>
                  {breadCrumb.component ? (
                    <Link to={breadCrumb.path}>
                      {breadCrumb.name?.toUpperCase()}
                    </Link>
                  ) : (
                    breadCrumb.name?.toUpperCase()
                  )}
                </BreadcrumbItem>
              ))}
            </Breadcrumb>
          </div>
          <h4 className="page-title">{title?.toUpperCase()}</h4>
        </div>
      </Col>
    </Row>
  );
};

export default PageTitle;
